import React, { ChangeEvent, useEffect, useRef, useState } from 'react';
import Form from 'react-bootstrap/Form';
import { api } from '../../../../api';
import styles from './PromotionStoryUuidField.module.scss';

type BookLookupResponse = { success: boolean; book: { title: string } | null };

interface PromotionStoryUuidFieldProps {
  value: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  onBlur?: () => void;
  error?: string;
  disabled?: boolean;
}

export function PromotionStoryUuidField(props: PromotionStoryUuidFieldProps) {
  const {
    value,
    onChange,
    onBlur,
    error,
    disabled = false,
  } = props;

  const [matchedBookTitle, setMatchedBookTitle] = useState<string | null>(null);
  const lookupSeq = useRef(0);
  const trimmed = value.trim();

  useEffect(() => {
    if (trimmed.length !== 36) {
      setMatchedBookTitle(null);
      return;
    }
    const seq = ++lookupSeq.current;
    const handle = window.setTimeout(() => {
      api
        .get<BookLookupResponse>(`/v1/books/by-uuid/${encodeURIComponent(trimmed)}`)
        .then((res) => {
          if (lookupSeq.current !== seq) return;
          setMatchedBookTitle(res.data?.book?.title ?? null);
        })
        .catch(() => {
          if (lookupSeq.current !== seq) return;
          setMatchedBookTitle(null);
        });
    }, 300);
    return () => {
      window.clearTimeout(handle);
    };
  }, [trimmed]);

  return (
    <Form.Group>
      <Form.Label>Story UUID</Form.Label>
      <div className={styles.storyUuidField}>
        <Form.Control
          type="text"
          name="storyUuid"
          className={styles.storyUuidInput}
          placeholder=""
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          isInvalid={!!error}
          disabled={disabled}
        />
        {matchedBookTitle ? (
          <span className={styles.bookTitle}>{matchedBookTitle}</span>
        ) : null}
      </div>
      <Form.Control.Feedback type="invalid" className="d-block">
        {error}
      </Form.Control.Feedback>
    </Form.Group>
  );
}
